import React from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';

import Header from '../../components/header';
import TopBanner from '../../components/products/topBanner';
import SectionWrapper from '../../components/products/events/SectionWrapper';
import ProductIntroduce from '../../components/products/events/ProductIntroduce';
import RegistrationAndTicketing from '../../components/products/events/RegistrationAndTicketing';
import FunctionalityTilesList from '../../components/products/membership/FunctionalityTilesList';

import { translate } from '../../../i18n';
import { colors, transition } from '../../utils/styles';

import PersonIcon from '../../images/products/membership/person_icon.svg';

import bannerImg from '../../images/products/engagement/engagement_banner.png';
import bannerImg2x from '../../images/products/engagement/engagement_banner@2x.png';
import bannerImg3x from '../../images/products/engagement/engagement_banner@3x.png';

import bannerIconImg from '../../images/products/engagement/engagement_banner_icon.png';
import bannerIconImg2x from '../../images/products/engagement/engagement_banner_icon@2x.png';
import bannerIconImg3x from '../../images/products/engagement/engagement_banner_icon@3x.png';

import segmentationImg from '../../images/products/engagement/segmentation.png';
import segmentationImg2X from '../../images/products/engagement/segmentation@2x.png';
import segmentationImg3X from '../../images/products/engagement/segmentation@3x.png';

import dragAndDropEmailImg from '../../images/products/engagement/drag_and_drop_email.png';
import dragAndDropEmailImg2X from '../../images/products/engagement/drag_and_drop_email@2x.png';
import dragAndDropEmailImg3X from '../../images/products/engagement/drag_and_drop_email@3x.png';

import statisticsImg from '../../images/products/engagement/statistics_img.png';
import statisticsImg2X from '../../images/products/engagement/statistics_img@2x.png';
import statisticsImg3X from '../../images/products/engagement/statistics_img@3x.png';

import dragAndDropFormImg from '../../images/products/engagement/drag_and_drop_form.png';
import dragAndDropFormImg2X from '../../images/products/engagement/drag_and_drop_form@2x.png';
import dragAndDropFormImg3X from '../../images/products/engagement/drag_and_drop_form@3x.png';

import mblApplicationImg from '../../images/products/engagement/mbl_application.png';
import mblApplicationImg2X from '../../images/products/engagement/mbl_application@2x.png';
import mblApplicationImg3X from '../../images/products/engagement/mbl_application@3x.png';

import lifestyleProfiling1Img from '../../images/products/engagement/lifestyle-profiling-01.png';
import lifestyleProfiling1Img2X from '../../images/products/engagement/lifestyle-profiling-01@2x.png';
import lifestyleProfiling1Img3X from '../../images/products/engagement/lifestyle-profiling-01@3x.png';

import lifestyleProfiling2Img from '../../images/products/engagement/lifestyle-profiling-02.png';
import lifestyleProfiling2Img2X from '../../images/products/engagement/lifestyle-profiling-02@2x.png';
import lifestyleProfiling2Img3X from '../../images/products/engagement/lifestyle-profiling-02@3x.png';

import lifestyleProfiling3Img from '../../images/products/engagement/lifestyle-profiling-03.png';
import lifestyleProfiling3Img2X from '../../images/products/engagement/lifestyle-profiling-03@2x.png';
import lifestyleProfiling3Img3X from '../../images/products/engagement/lifestyle-profiling-03@3x.png';

import lifestyleProfiling4Img from '../../images/products/engagement/lifestyle-profiling-04.png';
import lifestyleProfiling4Img2X from '../../images/products/engagement/lifestyle-profiling-04@2x.png';
import lifestyleProfiling4Img3X from '../../images/products/engagement/lifestyle-profiling-04@3x.png';

import appleStoreSvg from '../../images/products/engagement/apple_store.svg';

import googleStoreImg from '../../images/products/engagement/google_store.jpg';
import googleStoreImg2X from '../../images/products/engagement/google_store@2x.jpg';
import googleStoreImg3X from '../../images/products/engagement/google_store@3x.jpg';

import membershipImg from '../../images/products/engagement/membership_icon.svg';
import eventImg from '../../images/products/engagement/event_icon.svg';
import { LinkButton } from '../../components/commons';
import GetStarted from '../../components/products/GetStarted';

const { GATSBY_MANAGER_URL } = process.env;
const t = translate('pages/products/membership');

const SideCircleWrapper = styled.div`
  position: relative;
`;

const SideCircle = styled.div`
  background-image: linear-gradient(to bottom, #9de6ff, #64c9ff);
  position: absolute;
  z-index: 1;
  left: 80%;
  top: -10px;
  width: 360px;
  height: 197px;
  border-top-left-radius: 600px;
  border-top-right-radius: 600px;
  transform: rotate(-90deg);

  @media (max-width: 900px) {
    display: none;
  }
`;

const ProductIntroduceWrapper = styled.div`
  text-align: center;
  width: 100%;
`;

const SectionHeading = styled.h2`
  text-align: center;
  font-size: 25px;
  line-height: 1.2;
  font-weight: bold;
  margin: 0 auto;
  width: 100%;
  padding-bottom: ${ props =>
    props.paddingBottom ? `${ props.paddingBottom }px` : '20px' };
  text-transform: none;
  color: ${ ({ white }) => (white ? colors.white : colors.black) };

  @media (max-width: 900px) {
    font-size: ${ props =>
      props.fontSizeMob ? `${ props.fontSizeMob }px` : '25px' };
    width: 80%;
    padding-bottom: ${ props =>
      props.paddingBottomMob ? `${ props.paddingBottomMob }px` : '20px' };
  }
`;

const OverflowHidden = styled.div`
  overflow: hidden;
`;

const GetStartedBtn = styled.div`
  margin: 30px auto 0 auto;
  width: 174px;
  height: 42px;
  border-radius: 25px;
  background-color: white;
  color: #01a7ff;
  line-height: 2.8;
  font-size: 15px;
  font-weight: 700;
  text-align: center;

  &:after {
    content: 'Get started';
  }

  &:hover {
    background-color: ${ colors.mainBlue };
    color: white;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);
  }

  ${ transition('all 0.3s ease') };

  @media (max-width: 900px) {
    margin: 10px auto 0 auto;
  }
`;

const LifestyleImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const LifestyleImageWrapper = styled.div`
  flex-grow: 1;
  margin: 1%;
  flex-basis: 23%;
  @media (max-width: 900px) {
    flex-basis: 48%;
  }
`;

const Image = styled.img`
  max-width: 100%;
`;

const ProductDescription = styled.p`
  font-size: 15px;
  line-height: 1.6;
  width: 75%;
  margin: 10px auto 30px;
  text-align: center;

  @media (max-width: 900px) {
    font-size: 12px;
  }
`;

const MblAppIconContainer = styled.div`
  display: flex;
  padding-top: 30px;

  @media (max-width: 900px) {
    justify-content: center;
  }
`;

const MblAppIconWrapper = styled.a`
  padding-right: 20px;
`;

const AppImage = styled(Image)`
  max-height: 46px;
  height: 46px;
`;

const FunctionalityListInfo = [
  {
    title: 'Membership',
    description:
      'Customize your membership system, turn your contacts into members, and reward members with privileges and benefits.',
    link: '/products/membership',
    img_src: membershipImg,
    asCardLink: true
  },
  {
    title: 'Events',
    description:
      'Event management is really easy. Our ticketing system helps you throughout the event from checking in, in-event activities to post-event analytics.',
    link: '/products/events',
    img_src: eventImg,
    asCardLink: true
  }
];

const EngagementPage = () => (
  <div>
    <Helmet title={ t('Event Engagement and Membership Engagement | Juven') }>
      <meta
        name='description'
        content={ t(
          'Looking for a better membership management system? Juven is a smart and powerful online membership software to help engage with your members easily. Get started now!'
        ) }
      />
    </Helmet>
    <Header
      desktopNotFixed
      mobileHidden={ false }
      navigationBarNotFixed
      showLanguage
    />
    <TopBanner
      engagementPage
      bannerImageSrcSet={ `${ bannerImg3x } 3x, ${ bannerImg2x } 2x, ${ bannerImg } 1x` }
      headerIconSrcSet={ `${ bannerIconImg3x } 3x, ${ bannerIconImg2x } 2x, ${ bannerIconImg } 1x` }
      heading='Visual, informative, organized tools for driving engagement'
      subHeading='More engagement, better communication, increased loyalty'
      buttonText={ t('Try it today') }
      source='engagement'
    />
    <OverflowHidden>
      <SectionWrapper
        paddingTop='73'
        paddingBottomMob='90'
        customPaddingBottom='0'
      >
        <SectionHeading fontSizeMob='20'>
          { t('Engage with your community before and after the event') }
        </SectionHeading>
        <RegistrationAndTicketing
          noExtraMarginTop
          description={ t(
            'Enhance your pre and post event engagement by reviewing and analyzing real-time reports. Track your events in real time to get meaningful insights through detailed analytics. All this to organize better events and long-term membership engagement.'
          ) }
          ImgSpacingOnRight='5%'
          descriptionLineHeight='1.6'
          marginLeft='20px'
          descriptionInMid
          marginTopMob='30'
          contentMarginTop='10'
          headingMarginBottom='10'
          descriptionFontSize='12'
          imgSrc={ statisticsImg }
          srcSet={ `${ statisticsImg3X } 3x, ${ statisticsImg2X } 2x, ${ statisticsImg } 1x` }
          title={ t('Get the bigger picture') }
        />
        <RegistrationAndTicketing
          description={ t(
            'Collate all your contacts into one email marketing system to drive engagement. Create your own email templates with different functions and fields, send them off right away.'
          ) }
          descriptionLineHeight='1.6'
          alignLeft
          imgOnLeft
          descriptionInMid
          marginTop='90'
          marginTopMob='90'
          noExtraMarginTop
          contentMarginTop='10'
          headingMarginBottom='10'
          descriptionFontSize='12'
          imgSrc={ dragAndDropEmailImg }
          srcSet={ `${ dragAndDropEmailImg3X } 3x, ${ dragAndDropEmailImg2X } 2x, ${ dragAndDropEmailImg } 1x` }
          title={ t('Reduce repetitive email tasks') }
        />
        <RegistrationAndTicketing
          description={ t(
            'Faster responses and reaction on critical issues, always engage with your members to gather information and get feedbacks. Our easy-to-use form builder tools help you create any kind of surveys and forms.'
          ) }
          ImgSpacingOnRight='5%'
          descriptionLineHeight='1.6'
          marginLeft='20px'
          descriptionInMid
          marginTop='90'
          marginTopMob='90'
          noExtraMarginTop
          contentMarginTop='10'
          headingMarginBottom='10'
          descriptionFontSize='12'
          imgSrc={ dragAndDropFormImg }
          srcSet={ `${ dragAndDropFormImg3X } 3x, ${ dragAndDropFormImg2X } 2x, ${ dragAndDropFormImg } 1x` }
          title={ t('Build positive relationship') }
        />
        <RegistrationAndTicketing
          description={ t(
            'See everything you need in anytime, anywhere. Simplify your team\'s event management tasks, shorten guests\' waiting time, support membership service, improve the overall satisfaction in event organization and engagement.'
          ) }
          descriptionLineHeight='1.6'
          alignLeft
          imgOnLeft
          descriptionInMid
          marginTop='90'
          marginTopMob='90'
          noExtraMarginTop
          contentMarginTop='30'
          headingMarginBottom='10'
          descriptionFontSize='12'
          imgSrc={ mblApplicationImg }
          srcSet={ `${ mblApplicationImg3X } 3x, ${ mblApplicationImg2X } 2x, ${ mblApplicationImg } 1x` }
          title={ t('On-the-go with Juven Manager App') }
        >
          <MblAppIconContainer>
            <MblAppIconWrapper
              href='https://itunes.apple.com/us/app/juven-manager-app/id1438847545'
              target='_blank'
              rel='noopener noreferrer'
              id='engagement_mobile_app_ios'
            >
              <AppImage src={ appleStoreSvg } />
            </MblAppIconWrapper>
            <MblAppIconWrapper
              href='https://play.google.com/store/apps/details?id=com.juven.juvenmanagerapp'
              target='_blank'
              rel='noopener noreferrer'
              id='engagement_mobile_app_android'
            >
              <AppImage
                src={ googleStoreImg }
                srcSet={ `${ googleStoreImg3X } 3x, ${ googleStoreImg2X } 2x, ${ googleStoreImg } 1x` }
              />
            </MblAppIconWrapper>
          </MblAppIconContainer>
        </RegistrationAndTicketing>
      </SectionWrapper>

      <SideCircleWrapper>
        <SideCircle />
      </SideCircleWrapper>
      <SectionWrapper
        paddingTop='120'
        backgroundColor
        customPaddingBottom='105'
        paddingBottomMob='90'
      >
        <ProductIntroduceWrapper>
          <ProductIntroduce
            title={ t('Know your members') }
            imgSrc={ PersonIcon }
            fontSizeMob='20'
          />
          <ProductDescription>
            { t(
              'Boost membership engagement by really getting to know and understand your contacts\' interests and activities. Empower your community by responding to their behavior, needs and concerns.'
            ) }
          </ProductDescription>
        </ProductIntroduceWrapper>
        <LifestyleImageContainer>
          <LifestyleImageWrapper>
            <Image
              srcSet={ `${ lifestyleProfiling1Img3X } 3x, ${ lifestyleProfiling1Img2X } 2x, ${ lifestyleProfiling1Img } 1x` }
            />
          </LifestyleImageWrapper>
          <LifestyleImageWrapper>
            <Image
              srcSet={ `${ lifestyleProfiling2Img3X } 3x, ${ lifestyleProfiling2Img2X } 2x, ${ lifestyleProfiling2Img } 1x` }
            />
          </LifestyleImageWrapper>
          <LifestyleImageWrapper>
            <Image
              srcSet={ `${ lifestyleProfiling3Img3X } 3x, ${ lifestyleProfiling3Img2X } 2x, ${ lifestyleProfiling3Img } 1x` }
            />
          </LifestyleImageWrapper>
          <LifestyleImageWrapper>
            <Image
              srcSet={ `${ lifestyleProfiling4Img3X } 3x, ${ lifestyleProfiling4Img2X } 2x, ${ lifestyleProfiling4Img } 1x` }
            />
          </LifestyleImageWrapper>
        </LifestyleImageContainer>
        <RegistrationAndTicketing
          description={ t(
            'Find your target members by different search criteria and segment them for targeted messaging or other follow-up actions.'
          ) }
          descriptionLineHeight='1.6'
          alignLeft
          descriptionInMid
          marginTop='120'
          marginTopMob='90'
          contentLeftPadding='133'
          contentMarginTop='10'
          headingMarginBottom='10'
          descriptionFontSize='12'
          imgSrc={ segmentationImg }
          srcSet={ `${ segmentationImg3X } 3x, ${ segmentationImg2X } 2x, ${ segmentationImg } 1x` }
          title={ t('Search and Segmentation') }
        />
      </SectionWrapper>

      <GetStarted
        heading={ t('Start engaging your community on Juven!') }
        buttonText={ t('Try it today') }
        url={ `${ GATSBY_MANAGER_URL }/signup` }
        source='engagement'
      />
    </OverflowHidden>
    <SectionWrapper
      backgroundColor
      customPaddingBottom='130'
      paddingBottomMob='90'
    >
      <SectionHeading fontSizeMob='20'>
        { t('Explore other features in Juven') }
      </SectionHeading>
      <FunctionalityTilesList
        marginTopMbl='30'
        descriptionFontSize='20'
        list={ FunctionalityListInfo }
      />
    </SectionWrapper>
  </div>
);

export default EngagementPage;



// WEBPACK FOOTER //
// ./src/pages/products/engagement.jsx